import { Route, Routes } from 'react-router-dom';
import React, { useState } from 'react';
import './App.css';
import HomePage from './components/HomePage';
import AboutPage from './components/AboutPage';
import OverlayForm from './components/OverlayForm';
import PrivacyPolicy from './components/PrivacyPolicy';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

function App() {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  return (
    <div className="App">
      <div className="app">
        <Navbar />
        <Routes>
        <Route path="/"  element={<HomePage openFunc={openModal}/>} />
        <Route path="/privacy-policy"  element={<PrivacyPolicy/>} />
        <Route path="/about-us"  element={<AboutPage/>} />
        </Routes>
        <Footer />
        </div>
      <OverlayForm isOpen={modalIsOpen} onRequestClose={closeModal} />
    </div>
  );
}

export default App;
